import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";

export default function WireArticleCard({ article, href, featured = false, label = "Briefing", readLabel = "Read the briefing", openLabel = "Open" }) {
  if (featured) {
    return (
      <Link to={href} className="group grid overflow-hidden rounded-[2rem] border border-border bg-card shadow-xl shadow-ocean/10 transition hover:-translate-y-1 hover:border-primary/50 md:grid-cols-[0.9fr_1.1fr]">
        {article.heroImage && <img src={article.heroImage} alt="" className="h-72 w-full object-cover md:h-full" loading="eager" fetchPriority="high" />}
        <div className="flex flex-col justify-center p-6 md:p-8">
          <p className="text-sm font-black uppercase tracking-widest text-primary">{label} · {article.category}</p>
          <h2 className="mt-3 font-heading text-3xl font-black leading-tight md:text-5xl">{article.title}</h2>
          <p className="mt-4 text-base leading-7 text-muted-foreground">{article.excerpt}</p>
          <div className="mt-6 inline-flex items-center gap-2 text-sm font-black text-primary">{readLabel} <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" /></div>
        </div>
      </Link>
    );
  }

  return (
    <Link to={href} className="group flex h-full flex-col overflow-hidden rounded-3xl border border-border bg-card shadow-sm transition hover:-translate-y-1 hover:border-primary/50 hover:shadow-xl hover:shadow-ocean/10">
      {article.heroImage && <img src={article.heroImage} alt="" className="h-44 w-full object-cover" loading="lazy" />}
      <div className="flex flex-1 flex-col p-6">
        <p className="text-xs font-black uppercase tracking-widest text-primary">{article.category}</p>
        <h2 className="mt-3 text-xl font-black leading-tight text-foreground">{article.title}</h2>
        <p className="mt-3 flex-1 text-sm leading-6 text-muted-foreground">{article.excerpt}</p>
        <div className="mt-5 flex items-center justify-between gap-3 border-t border-border pt-4 text-sm font-black text-primary">
          <span className="inline-flex items-center gap-2 text-muted-foreground"><Clock className="h-4 w-4" /> {article.readTime}</span>
          <span className="inline-flex items-center gap-1">{openLabel} <ArrowRight className="h-4 w-4 transition group-hover:translate-x-1" /></span>
        </div>
      </div>
    </Link>
  );
}